import React from 'react';
import Button from '@material-ui/core/Button';

function Info(props) {

    const handleOk = () => {
        props.acceptCallback(false);
    }
    return (
        <div id="overlay" className={props.blur ? 'visible' : ''}>
            <div className={`box info ${props.popup ? 'show' : ''}`}>
                <h3>
                    {props.mainMessage}
                </h3>
                <p>
                    {props.secondaryMessage}
                </p>
                <div className="buttons">
                    <Button className="accept-request" onClick={handleOk}>
                        ОК
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default Info;